import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../components/LanguageSelector';
import { useAuth } from '../auth/AuthContext';
import { Link } from 'react-router-dom';
import { apiSend } from '../api/client';

export function SettingsPage() {
  const { t } = useTranslation(['common', 'auth']);
  const { user, logout } = useAuth();
  const [protectionMsg, setProtectionMsg] = useState<string | null>(null);

  async function protect(action: 'cooling_off' | 'self_exclude' | 'closure_request') {
    const until = new Date(Date.now() + 7 * 86400000).toISOString();
    try {
      await apiSend('POST', '/api/v1/account/protection', {
        action,
        until: action === 'closure_request' ? undefined : until,
      });
      setProtectionMsg(action);
    } catch (err) {
      setProtectionMsg(String(err));
    }
  }

  return (
    <div className="page">
      <h1>{t('common:settingsTitle', { defaultValue: 'Account settings' })}</h1>
      <section className="panel-block">
        <h2>{t('common:language', { defaultValue: 'Language' })}</h2>
        <LanguageSelector />
        <p className="muted-note">
          {user
            ? t('common:localePersisted', { defaultValue: 'Language preference is saved to your account when signed in.' })
            : t('common:localeLocal', { defaultValue: 'Language is stored locally until you sign in.' })}
        </p>
      </section>
      <section className="panel-block">
        <h2>{t('common:securityTitle', { defaultValue: 'Security' })}</h2>
        <p className="muted-note">
          {t('common:passwordResetPending', {
            defaultValue: 'Password recovery email delivery is BLOCKED until an SMTP provider is configured.',
          })}
        </p>
        <Link to="/security" className="btn btn-ghost">
          {t('common:securitySettings', { defaultValue: 'Security settings' })}
        </Link>
      </section>
      {user ? (
        <section className="panel-block">
          <h2>{t('common:protectionTitle', { defaultValue: 'Account protection' })}</h2>
          {protectionMsg ? <p className="muted-note">{protectionMsg}</p> : null}
          <div className="actions">
            <button type="button" className="btn btn-ghost" onClick={() => void protect('cooling_off')}>
              {t('common:coolingOff')}
            </button>
            <button type="button" className="btn btn-ghost" onClick={() => void protect('self_exclude')}>
              {t('common:selfExclude')}
            </button>
            <button type="button" className="btn btn-ghost" onClick={() => void protect('closure_request')}>
              {t('common:requestClosure')}
            </button>
          </div>
        </section>
      ) : null}
      {user ? (
        <button type="button" className="btn btn-primary" onClick={() => void logout()}>
          {t('auth:logout', { defaultValue: 'Log out' })}
        </button>
      ) : (
        <Link to="/auth/login" className="btn btn-primary">
          {t('common:login', { defaultValue: 'Log in' })}
        </Link>
      )}
    </div>
  );
}
